import type { SxProps, Theme } from '@mui/material/styles';

/**
 * Combines MUI `sx` values into the flat array shape required for composition.
 *
 * MUI does not expose a public `sx` merge helper, while `SxProps` allows an object,
 * a theme function, or a readonly array and MUI does not flatten nested `sx` arrays.
 * That union externalizes normalization onto every component that composes styles,
 * where forwarding an array as one element silently creates an invalid nested array.
 * This helper centralizes the normalization so components can safely put base styles
 * first and caller overrides last. Falsy parts are omitted to support conditional
 * expressions such as `condition && styles`.
 */
export function mergeSx(
  ...parts: Array<SxProps<Theme> | false | null | undefined>
): SxProps<Theme> {
  return parts.flatMap((part) => {
    if (!part) {
      return [];
    }

    return Array.isArray(part) ? part : [part];
  });
}
